import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, HostListener, Injectable, NgModule } from '@angular/core';
import * as i1 from 'abs-ngx-library/src/lib/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

var ToasterType;
(function (ToasterType) {
    ToasterType["Success"] = "Success";
    ToasterType["Error"] = "Error";
    ToasterType["Warning"] = "Warning";
    ToasterType["Info"] = "Info";
})(ToasterType || (ToasterType = {}));

const _c0 = (a0, a1) => [a0, a1];
const _c1 = a0 => ({ "top": a0 });
const _c2 = (a0, a1) => ({ maxWidth: a0, "background-color": a1 });
function ToasterALV1Component_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 9);
    i0.ɵɵelementContainerEnd();
} }
function ToasterALV1Component_div_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 10);
    i0.ɵɵelementContainerEnd();
} }
function ToasterALV1Component_div_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 11);
    i0.ɵɵelementContainerEnd();
} }
function ToasterALV1Component_div_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 12);
    i0.ɵɵelementContainerEnd();
} }
function ToasterALV1Component_div_0_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 13);
    i0.ɵɵlistener("click", function ToasterALV1Component_div_0_ng_container_11_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.interactiveElementEvent()); })("keyup.Enter", function ToasterALV1Component_div_0_ng_container_11_Template_button_keyup_Enter_1_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.interactiveElementEvent()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.data.interactiveElement);
} }
function ToasterALV1Component_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4);
    i0.ɵɵtemplate(3, ToasterALV1Component_div_0_ng_container_3_Template, 2, 0, "ng-container", 1)(4, ToasterALV1Component_div_0_ng_container_4_Template, 2, 0, "ng-container", 1)(5, ToasterALV1Component_div_0_ng_container_5_Template, 2, 0, "ng-container", 1)(6, ToasterALV1Component_div_0_ng_container_6_Template, 2, 0, "ng-container", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 5);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 6);
    i0.ɵɵtext(10);
    i0.ɵɵtemplate(11, ToasterALV1Component_div_0_ng_container_11_Template, 3, 1, "ng-container", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 7);
    i0.ɵɵlistener("click", function ToasterALV1Component_div_0_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r1); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.closeToasterEvent()); })("keyup.Enter", function ToasterALV1Component_div_0_Template_button_keyup_Enter_12_listener() { i0.ɵɵrestoreView(_r1); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.closeToasterEvent()); });
    i0.ɵɵelement(13, "span", 8);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c0, (ctx_r2.data == null ? null : ctx_r2.data.calledBy) == "ppms" ? "popup--toaster--ppms" : "popup--toaster", ctx_r2.options.class))("ngStyle", i0.ɵɵpureFunction1(13, _c1, (ctx_r2.data == null ? null : ctx_r2.data.calledBy) === "quantity-stepper-v3" ? ctx_r2.options == null ? null : ctx_r2.options.top : ""));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r2.data == null ? null : ctx_r2.data.type) == ctx_r2.toasterTypeEnum.Success);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r2.data == null ? null : ctx_r2.data.type) == ctx_r2.toasterTypeEnum.Warning);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r2.data == null ? null : ctx_r2.data.type) == ctx_r2.toasterTypeEnum.Error);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r2.data == null ? null : ctx_r2.data.type) == ctx_r2.toasterTypeEnum.Info);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", ctx_r2.data == null ? null : ctx_r2.data.message, ", ", ctx_r2.data.interactiveElement, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.data == null ? null : ctx_r2.data.message, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.data == null ? null : ctx_r2.data.interactiveElement);
} }
function ToasterALV1Component_ng_container_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "label", 23)(2, "span", 24);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 25);
    i0.ɵɵlistener("click", function ToasterALV1Component_ng_container_1_div_4_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(2); ctx_r2.trackAnalyticsEvents("opted-in", "checkbox", ctx_r2.isLearnMoreExpanded); return i0.ɵɵresetView(ctx_r2.onClickOfCheckbox()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 26);
    i0.ɵɵelement(6, "span", 27);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.data == null ? null : ctx_r2.data.checkBoxLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r2.isChecked);
} }
function ToasterALV1Component_ng_container_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.data == null ? null : ctx_r2.data.headerText, " ");
} }
function ToasterALV1Component_ng_container_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "a", 29);
    i0.ɵɵlistener("click", function ToasterALV1Component_ng_container_1_div_6_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.onClickExpandCollapse()); });
    i0.ɵɵtext(3, "Learn more ");
    i0.ɵɵelement(4, "span", 30);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.data == null ? null : ctx_r2.data.unsubscribeText, " ");
} }
function ToasterALV1Component_ng_container_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "button", 32);
    i0.ɵɵlistener("click", function ToasterALV1Component_ng_container_1_div_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r2 = i0.ɵɵnextContext(2); ctx_r2.trackAnalyticsEvents("opted-out", undefined, ctx_r2.isLearnMoreExpanded); return i0.ɵɵresetView(ctx_r2.closeToasterEvent(ctx_r2.data == null ? null : ctx_r2.data.closeAction)); });
    i0.ɵɵelement(2, "span", 33);
    i0.ɵɵelementEnd()();
} }
function ToasterALV1Component_ng_container_1_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "button", 32);
    i0.ɵɵlistener("click", function ToasterALV1Component_ng_container_1_div_8_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r2 = i0.ɵɵnextContext(2); ctx_r2.trackAnalyticsEvents("opted-in", undefined, ctx_r2.isLearnMoreExpanded); return i0.ɵɵresetView(ctx_r2.closeToasterEvent(ctx_r2.data == null ? null : ctx_r2.data.approveAction)); });
    i0.ɵɵelement(2, "span", 34);
    i0.ɵɵelementEnd()();
} }
function ToasterALV1Component_ng_container_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35)(1, "p", 36);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.data == null ? null : ctx_r2.data.learnMoreText);
} }
function ToasterALV1Component_ng_container_1_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37)(1, "button", 38);
    i0.ɵɵlistener("click", function ToasterALV1Component_ng_container_1_div_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(2); ctx_r2.trackAnalyticsEvents("save", undefined, ctx_r2.isLearnMoreExpanded); return i0.ɵɵresetView(ctx_r2.closeToasterEvent(ctx_r2.data == null ? null : ctx_r2.data.approveAction)); });
    i0.ɵɵtext(2, "Save");
    i0.ɵɵelementEnd()();
} }
function ToasterALV1Component_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 14)(2, "div", 15)(3, "div", 16);
    i0.ɵɵtemplate(4, ToasterALV1Component_ng_container_1_div_4_Template, 7, 2, "div", 17)(5, ToasterALV1Component_ng_container_1_div_5_Template, 2, 1, "div", 18)(6, ToasterALV1Component_ng_container_1_div_6_Template, 5, 1, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, ToasterALV1Component_ng_container_1_div_7_Template, 3, 0, "div", 19)(8, ToasterALV1Component_ng_container_1_div_8_Template, 3, 0, "div", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ToasterALV1Component_ng_container_1_div_9_Template, 3, 1, "div", 20)(10, ToasterALV1Component_ng_container_1_div_10_Template, 3, 0, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(8, _c2, ctx_r2.data == null ? null : ctx_r2.data.width, ctx_r2.data == null ? null : ctx_r2.data.bgColor));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.data == null ? null : ctx_r2.data.hasCheckBox);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r2.data == null ? null : ctx_r2.data.headerText) !== "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r2.data == null ? null : ctx_r2.data.unsubscribeText) !== "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.data == null ? null : ctx_r2.data.hasCloseButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.data == null ? null : ctx_r2.data.hasAcceptButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isLearnMoreExpanded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r2.data == null ? null : ctx_r2.data.hasSaveButton) && ctx_r2.isLearnMoreExpanded);
} }
class ToasterALV1Component {
    constructor(elementRef, _commonService) {
        this.elementRef = elementRef;
        this._commonService = _commonService;
        this.isOpen = false;
        this.closeToaster = new EventEmitter();
        this.isChecked = false;
        this.isLearnMoreExpanded = false;
        this.toasterTypeEnum = ToasterType;
        /* istanbul ignore next */
    }
    ngOnInit() {
        setTimeout(() => {
            if (this.data.interactiveElementLink) {
                $("#toasterIntElem").focus();
            }
            else {
                $("#toasterMessagev2").focus();
            }
        }, 200);
    }
    // Make active selected flow item
    onMouseUp(e) {
        if (this.isOpen) {
            const container = this.elementRef.nativeElement;
            !container.contains(e.target) && this.closeToasterEvent();
        }
        ;
    }
    closeToasterEvent(action = null) {
        this.closeToaster.emit(action ? action : {});
        if (this.isLearnMoreExpanded)
            this.isLearnMoreExpanded = false;
        if (this.isChecked)
            this.isChecked = false;
        if (!action && (this.data.toastType === 'email_optin_success' || this.data.toastType === 'text_optin_success')) {
            this.trackAnalyticsEvents('confirm');
        }
    }
    interactiveElementEvent() {
        if (this.data.interactiveElementLink) {
            window.open(this.data.interactiveElementLink);
        }
        else {
            this.closeToasterEvent();
            this._commonService._toasterInteractiveElement.next(true);
        }
    }
    rollBackFocusClose() {
        $("#toasterTextBtn").focus();
    }
    onClickOfCheckbox() {
        this.isChecked = !this.isChecked;
        this.isLearnMoreExpanded = !this.isLearnMoreExpanded;
    }
    onClickExpandCollapse() {
        this.isLearnMoreExpanded = !this.isLearnMoreExpanded;
        this.trackAnalyticsEvents('learn-more');
    }
    trackAnalyticsEvents(action, actionType, isLearnMoreExpanded) {
        if (window && window['AB'] && window['AB']['DATALAYER'] && action) {
            const page = this.data?.calledBy === 'weeklyad' ? 'weekly-ad' : this.data?.calledBy === 'account' ? 'account' : '';
            let isExpanded = isLearnMoreExpanded || this.isLearnMoreExpanded;
            if ((actionType === 'checkbox' && !this.isChecked) || actionType !== 'checkbox') {
                if (action === 'confirm' && window['appEventData'] && window['appEventData'][window['appEventData'].length - 1]?.link?.linkName?.indexOf('exp-') != -1) {
                    isExpanded = true;
                }
                window['AB']['DATALAYER'].setLinkClickEvents(`${page}|${isExpanded ? 'exp-' : ''}${this.data?.toastType === 'email_optin' || this.data.toastType === 'email_optin_success' ? 'email' : this.data?.toastType === 'text_optin' || this.data.toastType === 'text_optin_success' ? 'sms' : ''}-${action}`, true);
            }
        }
    }
    static { this.ɵfac = function ToasterALV1Component_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ToasterALV1Component)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.CommonService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ToasterALV1Component, selectors: [["app-toaster-al-v1"]], hostBindings: function ToasterALV1Component_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function ToasterALV1Component_click_HostBindingHandler($event) { return ctx.onMouseUp($event); }, false, i0.ɵɵresolveDocument);
        } }, inputs: { data: "data", options: "options", isOpen: "isOpen" }, outputs: { closeToaster: "closeToaster" }, decls: 2, vars: 2, consts: [["class", "popup popup-dark", "role", "alert", 3, "ngClass", "ngStyle", 4, "ngIf"], [4, "ngIf"], ["role", "alert", 1, "popup", "popup-dark", 3, "ngClass", "ngStyle"], [1, "popup__content"], [1, "popup__content__icon"], ["id", "toasterDescription", 1, "sr-only"], ["id", "toasterMessagev2", 1, "popup__content__text", "body-text-xs"], ["id", "toasterCloseBtnv2", "aria-label", "Close button", "aria-describedby", "toasterDescription", 1, "close-toaster-btn", "popup__close-btn", 3, "click", "keyup.Enter"], [1, "svg-icon", "svg-close-white"], [1, "svg-icon", "svg-success-filled"], [1, "svg-icon", "svg-warning-filled"], [1, "svg-icon", "svg-error-filled"], ["aria-label", "information", 1, "svg-icon", "svg-info-filled"], ["id", "toasterIntElem", 1, "popup__content__text__interactive-btn", 3, "click", "keyup.Enter"], [1, "popup", "mx-auto", "d-flex", "flex-column", 3, "ngStyle"], [1, "popup__content", "d-flex", "w-100"], [1, "popup__content__text", "w-100"], ["class", "checkbox w-100", 4, "ngIf"], ["class", "body-text-xs ml-4", 4, "ngIf"], ["class", "popup__content__buttons my-auto", 4, "ngIf"], ["class", "popup__content w-100 py-0", 4, "ngIf"], ["class", "mx-auto pb-2", 4, "ngIf"], [1, "checkbox", "w-100"], ["for", "checkboxMediumLabel", "aria-label", "Checkbox Label", 1, "checkbox__group"], [1, "checkbox__label", "checkbox__label--md", "w-100"], ["type", "checkbox", "aria-checked", "true", "id", "checkboxMediumLabel", 1, "checkbox__input", 3, "click", "checked"], [1, "checkbox__checkmark"], [1, "svg-checkmark"], [1, "body-text-xs", "ml-4"], [3, "click"], [1, "svg-caret-down"], [1, "popup__content__buttons", "my-auto"], ["type", "button", "aria-label", "Close", 1, "btn", "btn-secondary", "btn-circle--sm", 3, "click"], [1, "svg-icon", "svg-close-primary"], [1, "svg-icon", "svg-checkmark"], [1, "popup__content", "w-100", "py-0"], [1, "body-text-xs"], [1, "mx-auto", "pb-2"], ["aria-label", "button", 1, "btn", "btn-sm", "pds-btn-outlined--primary", 3, "click"]], template: function ToasterALV1Component_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ToasterALV1Component_div_0_Template, 14, 15, "div", 0)(1, ToasterALV1Component_ng_container_1_Template, 11, 11, "ng-container", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.calledBy) !== "weeklyad");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.data == null ? null : ctx.data.calledBy) === "weeklyad" && ctx.isOpen);
        } }, dependencies: [i2.NgClass, i2.NgIf, i2.NgStyle] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToasterALV1Component, [{
        type: Component,
        args: [{ selector: 'app-toaster-al-v1', template: "<!-- The top property assigned to ngStyle will be refactored as part of Quick Start Cart redesign-->\n<div *ngIf=\"data?.calledBy !== 'weeklyad'\" class=\"popup popup-dark\" [ngClass]=\"[data?.calledBy == 'ppms' ? 'popup--toaster--ppms' : 'popup--toaster', options.class]\" [ngStyle]=\"{'top':data?.calledBy === 'quantity-stepper-v3' ? options?.top : ''}\" role=\"alert\">\n  <div class=\"popup__content\">\n      <div class=\"popup__content__icon\">\n          <ng-container *ngIf=\"data?.type == toasterTypeEnum.Success\">\n              <span class=\"svg-icon svg-success-filled\"></span>\n          </ng-container>\n          <ng-container *ngIf=\"data?.type == toasterTypeEnum.Warning\">\n              <span class=\"svg-icon svg-warning-filled\"></span>\n          </ng-container>\n          <ng-container *ngIf=\"data?.type == toasterTypeEnum.Error\">\n              <span class=\"svg-icon svg-error-filled\"></span>\n          </ng-container>\n          <ng-container *ngIf=\"data?.type == toasterTypeEnum.Info\">\n              <span class=\"svg-icon svg-info-filled\" aria-label=\"information\"></span>\n          </ng-container>\n      </div>\n      <span class=\"sr-only\" id=\"toasterDescription\">\n        {{ data?.message }}, {{data.interactiveElement}}\n      </span>\n      <div id=\"toasterMessagev2\" class=\"popup__content__text body-text-xs\">\n          {{ data?.message }}\n          <ng-container *ngIf=\"data?.interactiveElement\">\n              <button id=\"toasterIntElem\" class=\"popup__content__text__interactive-btn\" (click)=\"interactiveElementEvent()\" (keyup.Enter)=\"interactiveElementEvent()\">{{data.interactiveElement}}</button>\n          </ng-container>\n      </div>\n        <button (click)=\"closeToasterEvent()\" (keyup.Enter)=\"closeToasterEvent()\" id=\"toasterCloseBtnv2\" aria-label=\"Close button\" class=\"close-toaster-btn popup__close-btn\" aria-describedby=\"toasterDescription\">\n            <span class=\"svg-icon svg-close-white\"></span>\n        </button>\n  </div>\n</div>\n\n\n<ng-container *ngIf=\"data?.calledBy === 'weeklyad' && isOpen\">\n    <div class=\"popup mx-auto d-flex flex-column\" [ngStyle]=\"{maxWidth: data?.width, 'background-color': data?.bgColor}\">\n        <div class=\"popup__content d-flex w-100\">\n            <div class=\"popup__content__text w-100\">\n                <div class=\"checkbox w-100\" *ngIf=\"data?.hasCheckBox\">\n                    <label class=\"checkbox__group\" for=\"checkboxMediumLabel\" aria-label=\"Checkbox Label\">\n                        <span class=\"checkbox__label checkbox__label--md w-100\">{{ data?.checkBoxLabel }}</span>\n                        <input class=\"checkbox__input\" type=\"checkbox\" [checked]=\"isChecked\" aria-checked=\"true\" id=\"checkboxMediumLabel\" (click)=\"trackAnalyticsEvents('opted-in', 'checkbox', isLearnMoreExpanded); onClickOfCheckbox()\">\n                        <span class=\"checkbox__checkmark\"><span class=\"svg-checkmark\"></span></span>\n                    </label>\n                </div>\n                <div class=\"body-text-xs ml-4\" *ngIf=\"data?.headerText !== ''\">\n                    {{ data?.headerText }}\n                </div>\n                <div class=\"body-text-xs ml-4\" *ngIf=\"data?.unsubscribeText !== ''\">\n                    {{ data?.unsubscribeText }} <a (click)=\"onClickExpandCollapse()\">Learn more <span class=\"svg-caret-down\"></span></a>\n                </div>\n            </div>\n            <div class=\"popup__content__buttons my-auto\" *ngIf=\"data?.hasCloseButton\">\n                <button type=\"button\" class=\"btn btn-secondary btn-circle--sm\" aria-label=\"Close\" (click)=\"trackAnalyticsEvents('opted-out', undefined, isLearnMoreExpanded); closeToasterEvent(data?.closeAction)\">\n                    <span class=\"svg-icon svg-close-primary\"></span>\n                </button>\n            </div>\n            <div class=\"popup__content__buttons my-auto\" *ngIf=\"data?.hasAcceptButton\">\n                <button type=\"button\" class=\"btn btn-secondary btn-circle--sm\" aria-label=\"Close\" (click)=\"trackAnalyticsEvents('opted-in', undefined, isLearnMoreExpanded); closeToasterEvent(data?.approveAction)\">\n                    <span class=\"svg-icon svg-checkmark\"></span>\n                </button>\n            </div>\n        </div>\n        <div class=\"popup__content w-100 py-0\" *ngIf=\"isLearnMoreExpanded\">\n            <p class=\"body-text-xs\">{{ data?.learnMoreText }}</p> \n        </div>\n        <div *ngIf=\"data?.hasSaveButton && isLearnMoreExpanded\" class=\"mx-auto pb-2\">\n            <button class=\"btn btn-sm pds-btn-outlined--primary\" aria-label=\"button\" (click)=\"trackAnalyticsEvents('save', undefined, isLearnMoreExpanded); closeToasterEvent(data?.approveAction)\">Save</button>\n        </div>\n    </div>\n</ng-container>\n" }]
    }], () => [{ type: i0.ElementRef }, { type: i1.CommonService }], { data: [{
            type: Input
        }], options: [{
            type: Input
        }], isOpen: [{
            type: Input
        }], closeToaster: [{
            type: Output
        }], onMouseUp: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ToasterALV1Component, { className: "ToasterALV1Component", filePath: "toaster-al-v1/toaster-al-v1.component.ts", lineNumber: 13 }); })();

class ToasterALV1Service {
    constructor(componentFactoryResolver, appRef, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
    }
    show(data, options = { top: '8vh' }, afterClose = () => { }) {
        // create a component reference from the component 
        const componentRef = this.componentFactoryResolver
            .resolveComponentFactory(ToasterALV1Component)
            .create(this.injector);
        const autoCloseTime = data.autoCloseTime || 0;
        // pass data
        componentRef.instance.data = data;
        componentRef.instance.options = options;
        const prevElement = $(data.prevIdToFocus);
        // open modal after miliseconds
        setTimeout(() => {
            componentRef.instance.isOpen = true;
            if (data.isSnsCheckbox) {
                setTimeout(() => $('.close-toaster-btn').focus(), 0);
            }
        });
        // auto close modal after miliseconds
        if (autoCloseTime) {
            setTimeout(() => {
                componentRef.instance.isOpen = false;
                this.appRef.detachView(componentRef.hostView);
                afterClose();
                if (data.isSnsCheckbox) {
                    setTimeout(() => prevElement.focus(), 0);
                }
                componentRef.destroy();
            }, autoCloseTime);
        }
        // close on click
        componentRef.instance.closeToaster.subscribe(val => {
            this.appRef.detachView(componentRef.hostView);
            afterClose();
            if (data.isSnsCheckbox) {
                setTimeout(() => prevElement.focus(), 0);
            }
            componentRef.destroy();
        });
        // Attach component to the appRef so that it's inside the ng component tree
        this.appRef.attachView(componentRef.hostView);
        // Get DOM element from component
        const domElem = componentRef.hostView
            .rootNodes[0];
        // Append DOM element to the body
        document.body.appendChild(domElem);
    }
    static { this.ɵfac = function ToasterALV1Service_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ToasterALV1Service)(i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(i0.Injector)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ToasterALV1Service, factory: ToasterALV1Service.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToasterALV1Service, [{
        type: Injectable
    }], () => [{ type: i0.ComponentFactoryResolver }, { type: i0.ApplicationRef }, { type: i0.Injector }], null); })();

class ToasterModule {
    static { this.ɵfac = function ToasterModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ToasterModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ToasterModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            ToasterALV1Service
        ], imports: [CommonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToasterModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ToasterALV1Component
                ],
                exports: [
                    ToasterALV1Component
                ],
                imports: [
                    CommonModule
                ],
                providers: [
                    ToasterALV1Service
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ToasterModule, { declarations: [ToasterALV1Component], imports: [CommonModule], exports: [ToasterALV1Component] }); })();

//Component

/**
 * Generated bundle index. Do not edit.
 */

export { ToasterALV1Component, ToasterALV1Service, ToasterModule, ToasterType };
